import React, { Fragment } from 'react';
import { withStyles } from "@material-ui/core/styles";
import { Box, Button } from "@material-ui/core";
import { DeleteOutline, FileCopyOutlined, VerticalAlignBottomOutlined, SwapHorizontalCircleOutlined } from '@material-ui/icons';
import PropTypes from 'prop-types';
import btnClose from '../assets/icons/white-black-close.png';
import { useDispatch, useSelector } from 'react-redux';
import { changeItemSelectedPopup, changeSelectedItems } from "../redux/actions/file-manager-actions";

import { useTranslate } from 'react-admin';
const StyledButton = withStyles(theme => ({
    root: {
        background: 'transparent',
        marginRight: theme.spacing(4),
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#ffffff',
    },
    label: {
        textTransform: 'capitalize',
        fontWeight: 'normal',
        marginLeft: theme.spacing(1)
    },
}))(Button);

function TableSelectedHeader({ onDelete, onDownload, onClear, openSysPopover }) {
    const translate = useTranslate();
    const dispatch = useDispatch();
    const { selectedItems, category } = useSelector(state => state.file_manager);

    const handleDelete = () => {
        const ids = selectedItems.map(item => item.id);
        onDelete(ids);
        dispatch(changeSelectedItems([]));
    }

    if (selectedItems.length > 0) {
        return (
            <Fragment>
                <Box display="flex" mt={1} px={2} py={1} bgcolor='#56657f'>
                    <Box >
                        <StyledButton
                            onClick={handleDelete}
                            variant='text'
                            startIcon={<DeleteOutline />}
                        >{translate('pos.categories.Delete')}</StyledButton>
                        <StyledButton
                            onClick={onDownload}
                            variant='text'
                            startIcon={<VerticalAlignBottomOutlined />}
                        >{translate('pos.categories.Download')}</StyledButton>
                        <StyledButton
                            onClick={(event) => {
                                openSysPopover(event, 'COPY');
                                dispatch(changeItemSelectedPopup(null));
                            }}
                            variant='text'
                            startIcon={<FileCopyOutlined />}
                        >{translate('pos.categories.Copy')}</StyledButton>
                        <StyledButton
                            onClick={(event) => {
                                openSysPopover(event, 'MOVE');
                                dispatch(changeItemSelectedPopup(null));
                            }}
                            variant='text'
                            startIcon={<SwapHorizontalCircleOutlined />}
                        >{translate('pos.categories.Move')}</StyledButton>
                    </Box>
                    {
                        category.level !== 2 && (
                            <Box marginLeft='auto'>
                                <StyledButton
                                    onClick={onClear}
                                    variant='text'
                                    startIcon={<img src={btnClose} width={16} />}
                                >{selectedItems.length} {selectedItems.length > 1 ? translate('pos.categories.filesSelected') : translate('pos.categories.fileSelected')}</StyledButton>
                            </Box>
                        )
                    }
                </Box>
            </Fragment>
        );
    }
    return null;
}

TableSelectedHeader.propTypes = {
    onDelete: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired
};

export default TableSelectedHeader;
